module.exports = __webpack_public_path__ + "static/media/adventures-logo-md.8063e48d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/adventures-logo-md.png
// module id = 242
// module chunks = 0